import React from 'react';
import './Signin.css';

class Signin extends React.Component {
    constructor(props){
        super(props);
        this.state={
            SigninEmail: '',
            SigninPassword: ''
        }
    }
    onEmailChange = (event) => {
        this.setState({SigninEmail: event.target.value})
    }
    onPasswordChange = (event) => {
        this.setState({SigninPassword: event.target.value})
    }
    onSubmitSignIn = () => {
        fetch('https://facerecoer.onrender.com/signin',{
            method: 'post',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                email: this.state.SigninEmail,
                password: this.state.SigninPassword
            })
        })
        .then(response => response.json())
        .then(user => {
            if(user.id){
                this.props.loadUser(user);
                this.props.onRouteChange('home');
            }
        })
    }

    render(){
        const { onRouteChange } = this.props;
        return(
            <article className="br2 b--black-20 w-100 w-50-m w-25-l mw6 shadow-5 center background">
                <main className="pa4 white-80">
                    <form className="measure">
                        <fieldset id="sign_up" className="ba b--transparent ph0 mh0">
                        <legend className="f1 fw6 ph0 mh0">Sign In</legend>
                        <div className="mt3">
                            <label className="db fw6 lh-copy f6" htmlFor="email-address">Email</label>
                            <input 
                                className="pa2 input-reset ba b--white bg-transparent hover-white w-100" 
                                type="email" 
                                name="email-address"  
                                id="email-address"
                                onChange={this.onEmailChange}
                            />
                        </div>
                        <div className="mv3">
                            <label className="db fw6 lh-copy f6" htmlFor="password">Password</label>
                            <input 
                                className="b pa2 input-reset ba b--white bg-transparent hover-white w-100" 
                                type="password" 
                                name="password"  
                                id="password"
                                onChange={this.onPasswordChange}
                            />
                        </div>
                        </fieldset>
                        <div className="">
                        <input onClick={this.onSubmitSignIn} className="b ph3 pv2 input-reset ba white-80 b--white bg-transparent grow pointer f6 dib" type="button" value="Sign in"/>
                        </div>
                        <div className="lh-copy mt3">
                        <p onClick={() => onRouteChange('register')} className="f6 link dim white-80 center und pointer">Register</p>
                        </div>
                    </form>
                </main>
            </article>
        );
    }   
}

export default Signin;